import { getFrontImage } from "@grandvisionhq/utils";
const parseListingProductData = (product, activeVariant) => {
  const image = getProductImageUrl(activeVariant);
  const name = product.name.en || "";
  const description = activeVariant.description;
  const brand = activeVariant.brand.name;
  const category = product.category || "";
  const sku = activeVariant.sku || "";
  return {
    name,
    image,
    description,
    brand,
    category,
    sku
  };
};
function getProductImageUrl(variant) {
  return getFrontImage(variant.images).url;
}
export {
  parseListingProductData
};
//# sourceMappingURL=parse-listing-product-data.js.map
